import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule, DaisyDialog } from '@app/ui';
import { HeaderSearchDialogComponent } from '../header-search-dialog/header-search-dialog.component';

@Component({
  selector: 'gb-header-platform-search',
  standalone: true,
  imports: [CommonModule, UiModule],
  templateUrl: './header-platform-search.component.html',
  styleUrls: ['./header-platform-search.component.scss'],
  host: {
    '[class.is-light]': 'light',
  },
})
export class HeaderPlatformSearchComponent {
  @Input() light = false;

  private dialog = inject(DaisyDialog);

  openSearch(): void {
    this.dialog.open(HeaderSearchDialogComponent, {
      width: '860px',
      scrollable: false,
      panelClass: 'search-dialog-panel',
    });
  }
}
